/**
 * Tipos de ocorrência do histórico da oportunidade (CRM): bloco comum 1 a 9 e específicos a partir de 20.
 * Espelha tipo_ocorrencia_oportunidade (db_crm) e TipoOcorrenciaOportunidadeEnum (API CRM). A Anotação (5) é
 * gravada pelo "Nova anotação" do histórico. Nome e ícone vêm do catálogo no struct da ocorrência.
 */
export enum TipoOcorrenciaOportunidadeEnum {
  Criacao = 1,
  Edicao = 2,
  MudancaEtapa = 3,
  Exclusao = 4,
  Anotacao = 5,
  Liberacao = 6,
  IntegracaoLancada = 7,
  IntegracaoExcluida = 8,
  FalhaIntegracao = 9,
  Reabertura = 20,
  AcaoPendente = 21,
  AcaoConcluida = 22,
  EnvioEmail = 23,
  Orcamento = 24,
  OrcamentoFormalizado = 25,
  Encerramento = 26,
  AnexoIncluido = 27,
  AnexoRemovido = 28,
  TagsAlteradas = 29,
  Arquivamento = 30,
  Desarquivamento = 31,
  StatusClienteAlterado = 32,
  VendedorAlterado = 33,
}
